// THIS FILE IS AUTO-GENERATED BY FIGMAGIC. DO NOT MAKE EDITS IN THIS FILE! CHANGES WILL GET OVER-WRITTEN BY ANY FURTHER PROCESSING.

const fontWeights = {
  bold: 800,
  medium: 700,
  regular: 500,
  light: 300,
}

export default fontWeights
